import React from 'react';

import edit from '@amzn/meridian-tokens/base/icon/edit';
import menuTokens from '@amzn/meridian-tokens/base/icon/menu';
import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { type TaskFormTableRow } from 'src/store/adminConfigPageSlice/regionTasksPageSlice/types';

import { ROW_LAYOUT } from '../constants';

// **** Functions **** //

/**
 * Content for "Description column"
 */
const getDescription = (row: TaskFormTableRow): string => {
  switch(row.type) {
    case 'task':
      return row.description;
    case 'task-group':
      return `Group - ${row.tasks.length} Task${row.tasks.length > 1 ? 's' : ''}`;
  }
};

/**
 * Content for "Modifications" column
 */
const getModificationCount = (row: TaskFormTableRow): number => {
  switch(row.type) {
    case 'task':
      return row.modifications.length;
    case 'task-group':
      return row.commonModifications.length;
  }
};


// **** Components **** //

/**
 * Default component
 */
const SortableRegionTaskRow = (props: { row: TaskFormTableRow }) => {
  const { row, ...otherProps } = props;
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: row.entityId,
    animateLayoutChanges: () => false,
  });

  return (
    <div
      className="sortable-region-task-row"
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
      }}
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      {...otherProps}
    >
      <Row widths={ROW_LAYOUT} width="100%" spacingInset={'none'}>
        <Text className="form-tasks-table__text">
          <Icon tokens={menuTokens} />
        </Text>
        <Text className="form-tasks-table__text">{row.rank == null ? 'Not Ranked' : row.rank}</Text>
        <Text className="form-tasks-table__text">{row.label}</Text>
        <Text className="form-tasks-table__text">{row.identifyBodyLocation ? 'Yes' : 'No'}</Text>
        <Text className="form-tasks-table__text">{row.measureUnit ?? ''}</Text>
        <Text className="form-tasks-table__text">{getDescription(row)}</Text>
        <Text className="form-tasks-table__text">{getModificationCount(row)}</Text>
        <Button type="icon" aria-label="Edit">
          <Icon tokens={edit} />
        </Button>
      </Row>
    </div>
  );
};

// **** Export **** //

export default SortableRegionTaskRow;
